// Filters.ts

// Helpers dos selects dos relatórios de Units e Floorplans. Os dados de cliente
// e projeto vêm do banco do dashboard (interface/Data), não do Analytics.

import type { SelectItem } from "../../components/Select";

// só o que os relatórios usam do cliente
export interface ReportClient {
    id             : string | number;
    comporate_name : string;
    qtd_projects   : string | number;
}

// só o que os relatórios usam do projeto
export interface ReportProject {
    company      : number;
    name_project : string;
}

export type ReportClientMap  = { [key: string]: ReportClient };
export type ReportProjectMap = { [key: string]: ReportProject };

// mantém a primeira opção ("All ...") no topo e ordena o restante pelo nome
export function SortOptions<T extends string | number>(list: SelectItem<T>[]): SelectItem<T>[] {
    return [ list[0], ...list.slice(1).sort((a, b) => a.name.localeCompare(b.name)) ];
}

// clientes que têm projeto liberado no contrato
export function ShowClientList(listClients: ReportClientMap): SelectItem<number>[] {
    const newData: SelectItem<number>[] = [{ "id": 0, "name": "All clients", "qtd_project": 0 }];

    Object.values(listClients).forEach((elem)=>{
        if(Number(elem.qtd_projects) > 0 && !newData.find(item => item.id === Number(elem.id))){
            newData.push({ "id": Number(elem.id), "name": elem.comporate_name, "qtd_project": Number(elem.qtd_projects) });
        }
    });

    return SortOptions(newData);
}

// nomes dos projetos do cliente escolhido, usados para casar com o que o
// Analytics devolve (lá o projeto só existe pelo nome)
export function ProjectNamesByCompany(listProjects: ReportProjectMap, company: number): string[] {
    return Object.values(listProjects)
        .filter(elem => elem.company === company)
        .map(elem => (elem.name_project || '').trim().toLowerCase());
}
